import { render, staticRenderFns } from "./RmpSelectBranchStep.vue?vue&type=template&id=5573180a"
import script from "./RmpSelectBranchStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpSelectBranchStep.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports